import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from "react-router-dom";
import QueryString from 'query-string';
import * as actions from '../../actions/user_actions';
import { Signout, PrivateRoute } from '../../components/Auth';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { TranslatedStyles } from '../../components/TranslatedStyles';
import { PATH_TO_COMPONENTS, REPORT_ROUTE_REMAP } from "./component_paths";
import SPECIALIZATION_COMPONENTS from '../../components/Specializations';

const { detect } = require('detect-browser');
const browser = detect();

const NotFoundRoute = ({ location, rootPath, allRoutePaths }) => {
  console.error(`Route not found: *${location.pathname}* root path is *${rootPath}* test ${allRoutePaths.includes(location.pathname)}`);

  if (rootPath === location.pathname) {
    console.error('Root path will redirect causing a loop');
    return null;
  } else {
    return <Redirect to='/' />;
  }
};

const OpSenseRoutes = ({ availableRoutes }) => {
  const fillRoutes = useCallback((routesToRender, subroutes, key, top) => {
    subroutes.forEach(route => {
      const menuChildren = route.children ? route.children.filter(subRoute => subRoute.showOnMenu) : [];

      const routeComponent = SPECIALIZATION_COMPONENTS[route.specialization ? route.specialization.componentToken : null] || PATH_TO_COMPONENTS[route.path];
      if (routeComponent) {
        routesToRender.push(<PrivateRoute key={key++} path={route.path} exact={true} component={routeComponent} />);
      } else {
        if (route.path in PATH_TO_COMPONENTS) {
          console.error(`The component is undefined for path: *${route.path}*`);
        } /*else {
          console.info(`Could not find component for path: *${route.path}*`);
        }*/
      }

      if (route.children) {
        // If the top menu item is selected this causes a redirect to the first sidebar menu item
        if (top && route.showOnMenu && menuChildren.length > 0) {
          routesToRender.push(<Route key={key++} path={route.path} exact={true} render={() => <Redirect from={route.path} to={menuChildren[0].path} />} />);
        }
        key = fillRoutes(routesToRender, route.children, key, false);
      }
    });

    return key;
  }, []);

  const topRoutes = [].concat(...availableRoutes.map(topRoute => topRoute.children ? topRoute.children.filter(subRoute => subRoute.showOnMenu) : []));
  if (topRoutes.length == 0) {
    console.error('No available top routes, this will be a problem.');
    return <div>Error loading screen</div>;
  } else {
    var key = 0;
    var routesToRender = [
      <Route key={key++} path='/' exact={true} render={() => <Redirect to={topRoutes[0].path} />} />,
      <Route key={key++} path='/signout' exact={ true } component={ Signout } />
    ];

    key = fillRoutes(routesToRender, availableRoutes, key, true);

    const allRoutePaths = routesToRender.map(route => route.props.path);

    routesToRender.push(<Route key={key++} render={(props) => <NotFoundRoute {...props} rootPath={topRoutes[0].path} allRoutePaths={allRoutePaths} />} />);

    return <Switch>{routesToRender}</Switch>;
  }
};

const consolidateReportRoutes = (routes) => {
  if (routes) {
    const reportingRoute = routes.find((route) => route.path === '/reporting');
    if (reportingRoute && reportingRoute.children && reportingRoute.children.length > 0 && reportingRoute.children[0].id < 100000) {
      let updatedChildren = [];

      REPORT_ROUTE_REMAP.forEach((remap) => {
        const matchingOriginalRoutes = reportingRoute.children.filter((childRoute) => Object.keys(remap.paths).find((path) => path === childRoute.path));
        if (matchingOriginalRoutes.length > 0) {
          updatedChildren.push({ 
            ...remap.route, 
            children: matchingOriginalRoutes.map((route) => ({
              ...route,
              showOnMenu: false,
              path: route.path.replace('/reporting', remap.route.path)
            }))
          });
        }
      });

      reportingRoute.children = updatedChildren;
    }
  }
  return routes;
};

const Main = ({ location, authenticated, me, currentGrouping, getUserMe }) => {
  const [stripnav, setStripnav] = useState(false);
  const availableRoutes = consolidateReportRoutes(me?.availableRoutes);

  useEffect(() => {
    const query = QueryString.parse(location?.search);
    setStripnav(query['stripnav'] === 'true' || query['print'] === 'true');

    if (localStorage.getItem('token')) {
      getUserMe();
    }
  }, [getUserMe]);

  if (!authenticated) {
    localStorage.removeItem('token');
    return <Redirect to={{ pathname: '/signin', state: { from: location, message: 'You need to sign in' } }} />
  } else if (browser && browser.name === 'ie' && parseInt(browser.version) < 8) {
    return <div>This browser is not supported.</div>
  } else if (availableRoutes && availableRoutes.length > 0 && currentGrouping) {
    return (
      <div className="app">
        <TranslatedStyles/>
        {stripnav ? null : <div className="top-menu-bg"></div>}
        {stripnav ? null : <div className="sub-menu-bg"></div>}

        {stripnav ? null : <Header availableRoutes={availableRoutes} />}

        <div className={`l-wrapper`}>
          <div className="l-wrapper__content">
            <OpSenseRoutes availableRoutes={availableRoutes} />
          </div>
        </div>

        { stripnav ? null : <Footer /> }

      </div>
    );
  } else {
    return <div className="loader">Loading...</div>;
  }
}

export default connect((state) => ({ authenticated: state.auth.authenticated, me: state.user.me, currentGrouping: state.currentGrouping.currentGrouping }), actions)(Main);
